import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../constants/Globals";
import { fetchAiRequestLimitExceedStatus, fetchAiResponseLimitExceedStatus, fetchClientSubscriptionStatus } from "../../services/SubscriptionSvc";
import { getClientOrganization } from "../../services/NetworkSvc";

function Forms({ selNetworkId }) {
  const [state, setState] = useState(1);
  const [loading, setLoading] = useState(true);
  const [forms, setForms] = useState([]);
  const [isClientSubscriptionActive, setIsClientSubscriptionActive] = useState(false);
  const [isAiResponseLimitExceed, setIsAiResponseLimitExceed] = useState(false);

  const getIsSubscriptionActiveStatus = async (selNetworkId) => {
    const isActive = await fetchClientSubscriptionStatus(selNetworkId);
    setIsClientSubscriptionActive(isActive);
  }

  const getAILimitExceedStatus = async (selNetworkId) => {
    const groupId = await getClientOrganization(selNetworkId);
    // console.log('Group id for AI limit check:::::::::::::', groupId);
    if (groupId && groupId > 0) {
      const isAiRespLimitExceed = await fetchAiResponseLimitExceedStatus(groupId);
      // console.log('AI limit exceed status:::::::::::::::::', isAiReqLimitExceed, isAiRespLimitExceed);
      setIsAiResponseLimitExceed(isAiRespLimitExceed);
    } else {
      alert('Organiation not found for the selected network!!!');
    }
  }

  useEffect(() => {
    if (selNetworkId) {
      getIsSubscriptionActiveStatus(selNetworkId);
      getAILimitExceedStatus(selNetworkId);
      axios
        .get(`${API_URL}/forms?clientId=${selNetworkId}`)
        .then(({ data }) => {
          setLoading(false);
          setForms(data.data);
        });
    }
  }, [selNetworkId, state]);

  const handleCreateFormClick = () => {
    if (isClientSubscriptionActive) {
      if (isAiResponseLimitExceed) {
        alert(`You've reached your limit for responses. Please upgrade or wait until limits reset`);
      } else {
        window.location.href = `/forms/new`;
      }
    } else {
      window.location.href = `/subscription-renew`;
    }
  }

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Content</strong>&nbsp;|&nbsp;Forms
        </div>
        {/* <Link to="/forms/new" className="blue-button size-l">
          Create Form
        </Link> */}
        <button
          className="btn btn-primary"
          onClick={handleCreateFormClick}
        >
          Create Form
        </button>
      </div>

      <div className="table-filters">
        <div className="table-pagination">{forms.length} Forms</div>
      </div>

      <div className="table-wrapper">
        <table
          className="table-body top-border"
          cellSpacing="0"
          cellPadding="0"
        >
          <tbody>
            {loading ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>Loading...</em>
                </td>
              </tr>
            ) : null}

            {!loading && !forms.length ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>No forms yet...</em>
                </td>
              </tr>
            ) : null}

            {forms.map(({ id, name, entriesCount, createdAt }) => (
              <tr key={id} className="table-row">
                <td className="table-cell table-cell-fluid">
                  <Link
                    to={`/forms/${id}`}
                    className="text-button inherit-font"
                  >
                    {name}
                  </Link>
                </td>
                <td className="table-cell table-cell-labelled" width="150">
                  <div>
                    Created
                    <br />
                    <strong>{moment(createdAt).format("MMM DD, Y")}</strong>
                  </div>
                </td>
                <td className="table-cell table-cell-labelled" width="120">
                  <div>
                    Entries
                    <br />
                    <strong>{entriesCount}</strong>
                  </div>
                </td>
                <td className="table-cell table-action" width="280">
                  <div className="inline-buttons">
                    <Link to={`/forms/${id}`} className="blue-button bordered">
                      Edit
                    </Link>
                    <button
                      className="blue-button bordered"
                      onClick={() => {
                        if (window.confirm("Are you sure?")) {
                          axios
                            .delete(`${API_URL}/forms/${id}`)
                            .then(() => setState(state * 2))
                            .then(() => {})
                            .catch(({ response }) => {
                              if (response.status === 500) {
                                alert(JSON.stringify(response.data.message));
                              }
                            });
                        }
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(Forms);
